export enum CurrencyAppActionTypes {
  FETCH_EXCHANGE_RATES_BEGIN = 'FETCH_EXCHANGE_RATES_BEGIN',
  FETCH_EXCHANGE_RATES_SUCCESS = 'FETCH_EXCHANGE_RATES_SUCCESS',
  FETCH_EXCHANGE_RATES_ERROR = 'FETCH_EXCHANGE_RATES_ERROR',
}
